import { createContext, useContext, useEffect, useState } from "react";

const PigContext = createContext();

export function PigProvider({ children }) {

  // ===============================
  // PIG MAIN STATES
  // ===============================

  const [pigLoaded, setPigLoaded] = useState(false);

  const [pigType, setPigType] = useState("rect");

  const [pigVisible, setPigVisible] = useState(false);

  const [pigX, setPigX] = useState(120);

  const [pigY, setPigY] = useState(300);

  const [direction, setDirection] = useState("x+");

  const [pigPage, setPigPage] = useState("launcher");

  const [pigPaused, setPigPaused] = useState(false);

  // ===============================
  // LIVE VALVES
  // ===============================

  const isXV1702Open =
    localStorage.getItem("isXV1702Open") === "true";

  const isXV1703Open =
    localStorage.getItem("isXV1703Open") === "true";

  const isXV1705Open =
    localStorage.getItem("isXV1705Open") === "true";

  const isXV1706Open =
    localStorage.getItem("isXV1706Open") === "true";

  const isXV1707Open =
    localStorage.getItem("isXV1707Open") === "true";

  const isXV1708Open =
    localStorage.getItem("isXV1708Open") === "true";

  const isXV1801Open =
    localStorage.getItem("isXV1801Open") === "true";

  const isXV1802Open =
    localStorage.getItem("isXV1802Open") === "true";

  // ===============================
  // FLOW SPEED
  // ===============================

  const FIC_1706 =
    Number(localStorage.getItem("FIC_1706")) || 0;

  // ===============================
  // LOAD PIG
  // ===============================

  const loadPig = (type = "rect") => {

    setPigLoaded(true);

    setPigVisible(true);

    setPigType(type);

    setPigPage("launcher");

    setPigX(140);

    setPigY(248);

    setDirection("MAIN");
  };

  // ===============================
  // REMOVE PIG
  // ===============================

  const removePig = () => {

    setPigLoaded(false);

    setPigVisible(false);
  };

  // ===============================
  // MAIN MOVEMENT ENGINE
  // ===============================

  useEffect(() => {

    if (!pigLoaded || !pigVisible) return;

    const interval = setInterval(() => {

      // ===========================
      // SPEED
      // ===========================

      let speed = 1;

      if (FIC_1706 >= 500) {
        speed = 4;
      }

      else if (FIC_1706 >= 250) {
        speed = 2;
      }

      // ===========================
      // START CONDITION
      // ===========================

      if (
        !isXV1702Open &&
        !isXV1703Open &&
        pigPage === "launcher"
      ) {
        return;
      }


      
      // ===========================
      // PAUSE CONDITIONS
      // ===========================

      // =====================================
      // XV1705 MAIN ISOLATION
      // =====================================

      // Pig has reached XV1705 but has not yet passed it.
      if (
        direction === "MAIN" &&
        pigX >= 650 &&
        pigX < 700 &&
        !isXV1705Open
      ) {
        setPigPaused(true);
        return;
      }

      // XV1707 is now a routing valve, not an isolation valve.
      // No pause is required here because the routing decision
      // will be handled later at X >= 1200.

      // Receiver isolation
      if (
        pigPage === "receiver" &&
        pigX <= 250 &&
        !isXV1801Open
      ) {
        setPigPaused(true);
        return;
      }

      setPigPaused(false);

      // ===========================
      // MAIN ROUTING
      // ===========================


     // ===========================
      // MAIN LAUNCHER PAGE
      // ===========================

      if (pigPage === "launcher") {

        // ==================================================
        // MAIN PIPELINE
        // ==================================================

        if (direction === "MAIN") {

          const nextX = pigX + speed;

          // Move pig
          setPigX(nextX);

          // -----------------------------
          // PRODUCTION BRANCH (XV1708)
          // -----------------------------

          if (nextX >= 775 && isXV1708Open) {
            setDirection("PROD_DOWN");
            return;
          }

          // -----------------------------
          // IMPORT BRANCH (XV1706)
          // -----------------------------

          if (nextX >= 1000 && isXV1706Open) {
            setDirection("IMPORT_UP");
            return;
          }

            // -----------------------------
            // XV1707 BRANCH
            // -----------------------------

            if (
              nextX >= 1038 &&
              isXV1707Open
            ) {

              setDirection("XV1707_DOWN");

              return;

            }

            if (nextX >= 1470) {

            setPigPage("receiver");

            setPigX(1200);

            setPigY(250);

            setDirection("RECEIVER_MAIN");

            return;

          }

            return;
        }

        // ==================================================
        // PRODUCTION BRANCH
        // ==================================================

        if (direction === "PROD_DOWN") {

          // Pig is still upstream of XV1708.
          if (!isXV1708Open && pigY < 320) {
            setPigPaused(true);
            return;
          }

          setPigPaused(false);

          const nextY = pigY + speed;

          setPigY(nextY);

          if (nextY >= 440) {
            setDirection("PROD_LEFT");
          }

          return;
        }

        if (direction === "PROD_LEFT") {

        const nextX = pigX - speed;

        setPigX(nextX);

        if (nextX <= 50) {

          removePig();

        }

        return;
      }

        // ==================================================
        // IMPORT BRANCH
        // ==================================================

        if (direction === "IMPORT_UP") {

          if (!isXV1706Open && pigY > 170) {
            setPigPaused(true);
            return;
          }

          setPigPaused(false);

          const nextY = pigY - speed;

          setPigY(nextY);

          if (nextY <= 106) {
            setDirection("IMPORT_RIGHT");
          }

          return;
        }

        if (direction === "IMPORT_RIGHT") {

          const nextX = pigX + speed;

          setPigX(nextX);

          if (nextX >= 1470) {

            removePig();

          }

          return;
        }

      }


      // ==================================================
      // XV1707 BRANCH
      // ==================================================

      if (direction === "XV1707_DOWN") {

      if (!isXV1707Open && pigY < 320) {
        setPigPaused(true);
        return;
      }

      setPigPaused(false);

      const nextY = pigY + speed;

      setPigY(nextY);

      if (nextY >= 380) {

        setDirection("XV1707_RIGHT");

      }

      return;

    }

      if (direction === "XV1707_RIGHT") {

        const nextX = pigX + speed;

        setPigX(nextX);

        if (nextX >= 1500) {

        setPigPage("receiver");

        setPigX(1200);

        setPigY(235);

        setDirection("RECEIVER_MAIN");

        return;

      }
      }

      // ===========================
// RECEIVER PAGE
// ===========================

if (pigPage === "receiver") {

  // =====================================
  // MAIN RECEIVER PIPELINE
  // =====================================

  if (direction === "RECEIVER_MAIN") {

    const nextX = pigX - speed;

    setPigX(nextX);

    // -------------------------
    // Receiver Isolation Valve
    // -------------------------

    if (
        pigX >= 650 &&
        pigX < 700 &&
        !isXV1801Open
      ) {

        setPigPaused(true);

        return;

      }

      setPigPaused(false);

    // -------------------------
    // Receiver Branch
    // -------------------------

    if (
      nextX <= 1020 &&
      isXV1802Open
    ) {

      setDirection("RECEIVER_DOWN");

      return;

    }

    // -------------------------
    // Straight Receiver End
    // -------------------------

    if (nextX <= 450) {

      removePig();

      return;

    }

    return;

  }

  // =====================================
  // RECEIVER DOWN BRANCH
  // =====================================

  if (direction === "RECEIVER_DOWN") {

    const nextY = pigY + speed;

    setPigY(nextY);

    if (nextY >= 350) {

      setDirection("RECEIVER_RIGHT");

    }

    return;

  }

        // =====================================
        // RECEIVER EXIT
        // =====================================

        if (direction === "RECEIVER_RIGHT") {

          const nextX = pigX + speed;

          setPigX(nextX);

          if (nextX >= 1450) {

            removePig();

          }

          return;

        }

      }

    }, 30);

    return () => clearInterval(interval);

  }, [

    pigLoaded,
    pigVisible,
    pigX,
    pigY,
    direction,
    pigPage,

    isXV1702Open,
    isXV1703Open,
    isXV1705Open,
    isXV1706Open,
    isXV1707Open,
    isXV1708Open,

    isXV1801Open,
    isXV1802Open,

    FIC_1706
  ]);

  return (

    <PigContext.Provider
      value={{

        pigLoaded,
        pigType,
        pigVisible,

        pigX,
        pigY,

        pigPage,

        pigPaused,

        loadPig,
        removePig
      }}
    >
      {children}
    </PigContext.Provider>
  );
}

export function usePig() {
  return useContext(PigContext);
}